<div
  luiIntersectionObserver
  #topObserver
  class="sticky-drawer-top-observer"
  [style.top]="topIntersectionMarginTop"
></div>

<ng-content select="lui-sticky-drawer-topbar"></ng-content>
<mat-drawer-container>
  <mat-drawer
    #drawer
    [mode]="_matDrawerMode"
    [position]="position"
    [style.width]="drawerWidth"
  >
    <div class="sticky-drawer-drawer">
      <div *ngIf="showCloseButton" class="sticky-drawer-close-button-container" data-test="sticky-drawer-close-button">
        <button luiIconButton (click)="drawer.toggle()">
          <mat-icon svgIcon="close_light"></mat-icon>
        </button>
      </div>
      <div class="sticky-drawer-drawer-container">
        <ng-content select="[luiStickyDrawerDrawer]"></ng-content>
      </div>
      <ng-content select="[luiStickyDrawerFooter]"></ng-content>
    </div>
  </mat-drawer>
  <mat-drawer-content luiIntersectionObserver #contentObserver>
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>
<div luiIntersectionObserver #bottomObserver></div>
